<template>
    <div>
        <v-radio-group v-model="radios">
            <StepRadioBtn
                v-for="(field, index) in form.inputs[0].fields"
                :key="`input-color-${index}`"
                :isChecked="selectedValue === field.value"
                :label="field.label"
                :sublabel="field.sublabel"
                :value="field.value"
                @select-value="selectValue"
            />
        </v-radio-group>
    </div>
</template>

<script>
    import StepRadioBtn from '@/components/myHabiteoStudio/steps/components/StepRadioBtn';

    export default {
        name: 'StepRadioGroup',
        components: {
            StepRadioBtn
        },
        props: {
            form: {
                type: Object,
                required: true
            },
            selectedValue: {
                type: Number,
                required: false
            }
        },
        data() {
            return {
                radios: null
            }
        },
        mounted() {
            this.radios = this.$props.selectedValue;
        },
        methods: {
            selectValue() {
                this.$props.form.inputs[0].value = this.radios;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/components/StepRadioGroup.vue